<template>
  <sec-page>
    <sec-hero :eyebrow="page.hero.eyebrow" :title="page.hero.title" :lede="page.hero.lede">
      <sec-note :value="page.hero.note" />
    </sec-hero>

    <sec-section>
      <sec-scorer />
    </sec-section>
  </sec-page>
</template>

<script setup>
// Free ten-question self score. Replaces "Schedule a Meeting" as the header call to action.
import SecPage from '@/components/security/ui/SecPage.vue';
import SecHero from '@/components/security/ui/SecHero.vue';
import SecSection from '@/components/security/ui/SecSection.vue';
import SecNote from '@/components/security/ui/SecNote.vue';
import SecScorer from '@/components/security/scorer/SecScorer.vue';
import { SCORE_PAGE } from '@/content/security/score';

const page = SCORE_PAGE;
</script>
